<template>
    <v-sheet variant="flat" class="w-100 kiwi-radius-6 kiwi-bg-light-grey-5 qbts-card overflow-hidden" border>
        <div class="qbts-card-header py-4 px-4 d-flex align-center kiwi-bg-white">
            <slot name="qbtsHeader" />
        </div>
        <v-divider class="ma-0"></v-divider>
        <slot />
    </v-sheet>
</template>